<template>
  <div class="zoox-component zoox-card-template">
    <z-card class="zoox-card-template-card" width="100%" height="100%">
      <template #content>
        <div class="template-header" :class="{[align]: true}">
          <h3 class="template-title">{{ title }}</h3>
          <div
            v-if="description"
            class="template-description body3"
            :class="{[align]: true}"
            :style="{'justify-content': align}"
          >
            <span>
              {{ description }}
            </span>
          </div>
        </div>
        <slot name="content"></slot>
      </template>
    </z-card>
  </div>
</template>

<script>
/**
 * Componente de template de página, que é utilizado para construir a estrutura
 * da página. Normalmente esse template vai ser o "esqueleto" de uma página completa,
 * quando o conteúdo da página deve ser exibido em um único card, que ocupa a maior parte da tela
 * @displayName Simple Card Template
 * @private
 */
export default {
  name: 'ZSimpleCardTemplate',
  props: {
    /**
     * Título da página
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Descrição da página
     */
    description: {
      type: String,
      default: '',
    },
    /**
     * Alinhamento do título e da descrição
     * no card
     *
     * @values center,start,end
     */
    align: {
      type: String,
      default: 'center',
    },
    /**
     * Flag para indicar que a página não
     * permite scroll lateral externo. Deve
     * ocupar no máximo 100%
     */
    scrolless: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-card-template {
  height: calc(100vh - 48px);
  padding: 15px 15px;
}

.zoox-card-template-card {
  padding-top: 35px;
  padding-left: 35px;
  padding-right: 35px;
}

.template-header {
  text-align: center;
  margin-bottom: 20px;
  display: grid;
  row-gap: 15px;

  .template-description {
    display: flex;
  }

  .template-description > span {
    max-width: 500px;
  }

  &.center,
  &.center > .template-description {
    text-align: center;
  }
  &.start,
  &.start > .template-description {
    text-align: start;
  }
  &.end,
  &.end > .template-description {
    text-align: end;
  }
}
</style>
